const MODULE_NAME = "PATIENT_SENSOR_PACKAGES";
const FETCH_SENSOR_PACKAGES_STARTED = MODULE_NAME + "FETCH_SENSOR_PACKAGES_STARTED";
const FETCH_SENSOR_PACKAGES_COMPLETED = MODULE_NAME + "FETCH_SENSOR_PACKAGES_COMPLETED";
const FETCH_SENSOR_PACKAGES_FAILED = MODULE_NAME + "FETCH_SENSOR_PACKAGES_FAILED";

export {
  FETCH_SENSOR_PACKAGES_STARTED,
  FETCH_SENSOR_PACKAGES_COMPLETED,
  FETCH_SENSOR_PACKAGES_FAILED
};
